export default __webpack_public_path__ + "static/media/Asset 4.521c5ce7.png";